import { render, staticRenderFns } from "./IntroductoryModal.vue?vue&type=template&id=28fb005c&scoped=true&"
import script from "./IntroductoryModal.vue?vue&type=script&lang=js&"
export * from "./IntroductoryModal.vue?vue&type=script&lang=js&"
import style0 from "./IntroductoryModal.vue?vue&type=style&index=0&id=28fb005c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fb005c",
  null
  
)

export default component.exports